
import { CreatomateFont, BuiltInFontDefinition } from "./BuiltInFonts";

export const CreatomateComcastFonts: CreatomateFont[] = [
  {
    family: "Comcast New Vision Regular",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-Regular.otf"
  }, {
    family: "Comcast New Vision Regular Italic",
    weight: 400,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-RegularItalic.otf"
  },
  {
    family: "Comcast New Vision Semi Bold",
    weight: 600,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-SemiBold.otf"
  }, {
    family: "Comcast New Vision Semi Bold Italic",
    weight: 600,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-SemiBoldItalic.otf"
  }, {
    family: "Comcast New Vision Bold",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-Bold.otf"
  }, {
    family: "Comcast New Vision Bold Italic",
    weight: 700,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-BoldItalic.otf"
  }, {
    family: "Comcast New Vision Extra Bold",
    weight: 800,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-ExtraBold.otf"
  }, {
    family: "Comcast New Vision Extra Bold Italic",
    weight: 800,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-ExtraBoldItalic.otf"
  }, {
    family: "Comcast New Vision Extra Light",
    weight: 250,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-ExtraLight.otf"
  }, {
    family: "Comcast New Vision Extra Light Italic",
    weight: 250,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-ExtraLightItalic.otf"
  }, {
    family: "Comcast New Vision Light",
    weight: 300,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-Light.otf"
  }, {
    family: "Comcast New Vision Light Italic",
    weight: 300,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-LightItalic.otf"
  }, {
    family: "Comcast New Vision Medium",
    weight: 500,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-Medium.otf"
  }, {
    family: "Comcast New Vision Medium Italic",
    weight: 500,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-MediumItalic.otf"
  }
];

export const BuiltInComcastFonts: BuiltInFontDefinition[] = [
  {
    family: "Comcast New Vision Regular",
    weights: [400],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-Regular.otf"
  }, {
    family: "Comcast New Vision Regular Italic",
    weights: [400],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-RegularItalic.otf"
  },
  {
    family: "Comcast New Vision Semi Bold",
    weights: [600],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-SemiBold.otf"
  }, {
    family: "Comcast New Vision Semi Bold Italic",
    weights: [600],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-SemiBoldItalic.otf"
  }, {
    family: "Comcast New Vision Bold",
    weights: [700],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-Bold.otf"
  }, {
    family: "Comcast New Vision Bold Italic",
    weights: [700],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-BoldItalic.otf"
  }, {
    family: "Comcast New Vision Extra Bold",
    weights: [800],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-ExtraBold.otf"
  }, {
    family: "Comcast New Vision Extra Bold Italic",
    weights: [800],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-ExtraBoldItalic.otf"
  }, {
    family: "Comcast New Vision Extra Light",
    weights: [250],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-ExtraLight.otf"
  }, {
    family: "Comcast New Vision Extra Light Italic",
    weights: [250],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-ExtraLightItalic.otf"
  }, {
    family: "Comcast New Vision Light",
    weights: [300],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-Light.otf"
  }, {
    family: "Comcast New Vision Light Italic",
    weights: [300],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-LightItalic.otf"
  }, {
    family: "Comcast New Vision Medium",
    weights: [500],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-Medium.otf"
  }, {
    family: "Comcast New Vision Medium Italic",
    weights: [500],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/comcast/ComcastNewVision-MediumItalic.otf"
  }
];
